import * as React from 'react'
import {
  Datagrid,
  List,
  Create,
  Edit,
  TextField,
  TextInput,
  ArrayInput,
  SimpleFormIterator,
  ReferenceInput,
  NumberInput,
  ReferenceField,
  Show,
  SimpleShowLayout,
  NumberField,
  ArrayField,
  SingleFieldList,
  Filter,
  AutocompleteInput,
} from 'react-admin'

import { Box } from '@material-ui/core'
import { TabbedForm } from '../components/TabbedForm'
import { hasDuplicates } from './assessment_instances'
import {
  ArchivedSelect,
  CourseField,
  CourseIdSelect,
  CourseSelect,
} from '../components/selects'
import { useCourseIds } from '../utils/useCourseIds'

const ListBase = (props) => {
  const course_ids = useCourseIds()
  return (
    <List
      filter={course_ids ? { course_id: course_ids } : null}
      filters={<AssessmentFilter />}
      sort={{ field: 'name', order: 'ASC' }}
      perPage={25}
      {...props}
    >
      <AssessmentList {...props} />
    </List>
  )
}

const ShowBase = (props) => (
  <Show {...props}>
    <AssessmentShow />
  </Show>
)

const CreateBase = (props) => (
  <Create {...props}>
    <AssessmentForm />
  </Create>
)

const EditBase = (props) => (
  <Edit undoable={false} {...props}>
    <AssessmentForm />
  </Edit>
)

export const list = ListBase
export const edit = EditBase
export const show = ShowBase
export const create = CreateBase

const AssessmentList = (props) => (
  <Datagrid
    rowClick={props.permissions?.includes('admin') ? 'edit' : 'show'}
    {...props}
  >
    <TextField label="Assessment Name" source="name" />
    <CourseField />
  </Datagrid>
)

const AssessmentFilter = (props) => (
  <Filter style={{ margin: 10 }} {...props}>
    <CourseIdSelect alwaysOn />
    <ArchivedSelect />
  </Filter>
)

const AssessmentShow = (props) => (
  <SimpleShowLayout {...props}>
    <TextField fullWidth source="name" />
    <CourseField />

    <NumberField label="Duration in minutes" source="duration" />

    <NumberField fullWidth source="team_size" label="Members per Team" />
    <NumberField source="student_ratio" label="Students per Instructor" />

    <ArrayField source="events">
      <SingleFieldList>
        <ReferenceField label="Event" source="event_id" reference="events">
          <TextField source="name" />
        </ReferenceField>
      </SingleFieldList>
    </ArrayField>
  </SimpleShowLayout>
)

const AssessmentForm = (props) => (
  <TabbedForm
    {...props}
    labels={['Basic', 'Events']}
    pages={[DetailsPage, EventsPage]}
  />
)

const DetailsPage = (props) => (
  <Box>
    <TextInput fullWidth label="Assessment Name" source="name" />

    <CourseSelect />

    {/* <SelectInput
      fullWidth
      source="type"
      label="Performance or Knowledge Based?"
      defaultValue="performance"
      choices={[
        { id: 'performance', name: 'Performance' },
        { id: 'knowledge', name: 'Knowledge' },
      ]}
    /> */}

    <NumberInput
      fullWidth
      defaultValue={60}
      label="Duration in minutes"
      source="duration"
    />

    <NumberInput fullWidth source="team_size" label="Members per Team" />
    <NumberInput
      fullWidth
      source="student_ratio"
      label="Students per Instructor"
    />
  </Box>
)

const EventsPage = (props) => (
  <ArrayInput
    validate={(value) => {
      if (hasDuplicates(value?.map((e) => e?.event_id))) {
        return 'Assessment cannot contain duplicate events'
      }
      return []
    }}
    source="events"
  >
    <SimpleFormIterator>
      <ReferenceInput
        fullWidth
        allowEmpty={false}
        perPage={100}
        label="Event"
        source="event_id"
        sort={{ field: 'name', order: 'ASC' }}
        reference="events"
      >
        <AutocompleteInput optionText="name" translateChoice={false} />
      </ReferenceInput>
    </SimpleFormIterator>
  </ArrayInput>
)
